import { render, staticRenderFns } from "./students.vue?vue&type=template&id=22ec4a3c&scoped=true&"
import script from "./students.vue?vue&type=script&lang=js&"
export * from "./students.vue?vue&type=script&lang=js&"
import style0 from "./students.vue?vue&type=style&index=0&id=22ec4a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec4a3c",
  null
  
)

export default component.exports